// File: src/components/layout/Footer.tsx
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';
import { useLocalizedPath } from '../../i18n/localeRouting';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useI18n();
  const lp = useLocalizedPath();

  const linkStyles = "text-muted hover:text-validator-text transition-colors duration-200";
  const headingStyles = "text-sm font-semibold text-primary tracking-wider uppercase mb-3";

  return (
    <footer className="bg-surface-alt border-t border-subtle mt-auto">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        {/* Logo for mobile - centered at the top */}
        <div className="flex justify-center mb-8 sm:hidden">
          <div className="flex flex-col items-center">
            <Link to={lp('/')}>
              <img className="h-12 w-auto mb-2" src="/logo.png" alt="Scrabble Mini logo" />
            </Link>
            <Link to={lp('/docs/strategy')} className="hover:text-validator-text transition-colors duration-200">
              <span className="font-bold text-md text-secondary">{t('taglineShort')}</span>
            </Link>
          </div>
        </div>

        {/* Main footer content */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-4 sm:gap-x-6 md:gap-x-8">

          {/* Column 1: Tools */}
          <div className="space-y-2">
            <h3 className={headingStyles}>{t('footerToolsTitle')}</h3>
            <ul className="space-y-2">
              <li><Link to={lp('/lookup')} className={linkStyles}>{t('navValidator')}</Link></li>
              <li><Link to={lp('/word-finder')} className={linkStyles}>{t('navFinder')}</Link></li>
              <li><Link to={lp('/anagram-solver')} className={linkStyles}>{t('navAnagram')}</Link></li>
              <li><Link to={lp('/magic')} className="text-magic-text hover:text-magic-hover transition-colors duration-200">✨ {t('navMagic')}</Link></li>
              <li><Link to={lp('/practice')} className="text-practice-text hover:text-practice-hover transition-colors duration-200">{t('navPractice')}</Link></li>
            </ul>
          </div>

          {/* Column 2: Resources */}
          <div className="space-y-2">
            <h3 className={headingStyles}>{t('footerResourcesTitle')}</h3>
            <ul className="space-y-2">
              <li><Link to={lp('/docs/readme')} className={linkStyles}>{t('footerLinkDocs')}</Link></li>
              <li><Link to={lp('/about')} className={linkStyles}>{t('footerLinkAbout')}</Link></li>
              <li><Link to={lp('/docs/tech_stack')} className={linkStyles}>{t('footerLinkTechStack')}</Link></li>
              <li><a href="https://github.com/RCushmaniii/scrabble-mini" target="_blank" rel="noopener noreferrer" className={linkStyles}>{t('footerLinkGitHub')}</a></li>
            </ul>
          </div>

          {/* Column 3: Legal */}
          <div className="space-y-2">
            <h3 className={headingStyles}>{t('footerLegalTitle')}</h3>
            <ul className="space-y-2">
              <li><Link to={lp('/docs/privacy')} className={linkStyles}>{t('footerLinkPrivacy')}</Link></li>
              <li><Link to={lp('/docs/terms')} className={linkStyles}>{t('footerLinkTerms')}</Link></li>
            </ul>
          </div>

          {/* Column 4: Branding/Logo - Hidden on mobile, shown on tablet and up */}
          <div className="hidden sm:flex items-start justify-end">
            <div className="flex flex-col items-center">
              <Link to={lp('/')}>
                <img className="h-12 w-auto mb-2" src="/logo.png" alt="Scrabble Mini logo" />
              </Link>
              <Link to={lp('/docs/strategy')} className="hover:text-validator-text transition-colors duration-200">
                <span className="font-bold text-md text-secondary">{t('taglineLong')}</span>
              </Link>
            </div>
          </div>

        </div>

        {/* Copyright notice */}
        <div className="mt-8 pt-6 border-t border-subtle text-center">
          <p className="text-sm text-muted">&copy; {currentYear} {t('footerCopyright')}</p>
        </div>
      </div>
    </footer>
  );
}